import React, { useState, useMemo } from "react";
import Box from "@mui/material/Box";
import { Typography, Grid, TextField, Card, CardContent } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { Page, Text, View, Document, PDFViewer } from "@react-pdf/renderer";
import { useMaterialUIController } from "context";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import DescriptionIcon from "@mui/icons-material/Description";
import CancelIcon from "@mui/icons-material/Cancel";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import {
  FP,
  PageHeader,
  StatCard,
  fpDataGridSx,
  fpInputSx,
} from "components/financepro";
import { useApi, useSucursales } from "lib/api";

function Interescobradoperiodo() {
  const [fecha1, setFecha1] = useState("");
  const [fecha2, setFecha2] = useState("");
  const [nosucursal, setNosucursal] = useState("");
  const [rows, setRows] = useState([]);
  const [presentarpdf, setPresentarpdf] = useState(false);

  const [controller] = useMaterialUIController();
  const { nombreNegocio } = controller;
  const { post } = useApi();
  const sucursal = useSucursales();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  const formatValorCell = (value) => {
    if (value == null || value === "") return "";
    const n = parseFloat(String(value).replace(",", "").trim());
    return Number.isFinite(n) ? n.toFixed(2) : String(value);
  };

  const columns = useMemo(
    () => [
      { field: "id", headerName: "DOC #", width: 90, align: "center", headerAlign: "center" },
      { field: "nombres", headerName: "Nombres", flex: 1, minWidth: 130 },
      { field: "apellidos", headerName: "Apellidos", flex: 1, minWidth: 130 },
      {
        field: "valor",
        headerName: "Valor",
        width: 130,
        align: "right",
        headerAlign: "right",
        valueGetter: (value) => formatValorCell(value),
      },
    ],
    []
  );

  async function procesarrequerimiento() {
    const { status, data } = await post("/api/interescobradosperiodos", {
      fechadesde: fecha1,
      fechahasta: fecha2,
      sucursal: nosucursal,
    });
    if (status === 200) {
      setRows(data["cobros"]);
    } else if (status === 400) {
      setRows([]);
      alert(data["Error"]);
    }
  }

  const MyDocument = ({ rowsData, nombreNegocio1 }) => {
    const totalValorPDF = (rowsData || []).reduce(
      (sum, row) => sum + (parseFloat(String(row.valor || 0).replace(",", "").trim()) || 0),
      0
    );
    return (
      <PDFViewer style={{ height: isXs ? "calc(100vh - 120px)" : "550px", width: "100%", colorScheme: "light", background: "#fff" }}>
        <Document>
          <Page size="A4" orientation="Portrait" wrap style={{ backgroundColor: "#FFFFFF", paddingBottom: 65 }}>
            <View style={{ textAlign: "center", width: "94%", fontSize: 10, textTransform: "uppercase", marginTop: "15px" }} fixed>
              <Text>{nombreNegocio1 || "Empresa"}</Text>
            </View>
            <View style={{ textAlign: "center", width: "94%", fontSize: 9, textTransform: "uppercase" }} fixed>
              <Text>Interes Cobrado por Periodo</Text>
            </View>
            <View style={{ display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "left", width: "94%", height: "25px", fontSize: 10, backgroundColor: "#1976d2", color: "white", marginLeft: "15px" }} fixed>
              <Text style={{ width: "75px", textAlign: "left", fontWeight: "bold" }}>DOC #</Text>
              <Text style={{ width: "160px", textAlign: "left", fontWeight: "bold" }}>Nombres</Text>
              <Text style={{ width: "160px", textAlign: "left", fontWeight: "bold" }}>Apellidos</Text>
              <Text style={{ width: "130px", textAlign: "right", fontWeight: "bold" }}>Valor</Text>
            </View>
            {(rowsData || []).map((filas, i) => (
              <View key={i} style={{ flexDirection: "row", width: "94%", height: "15px", fontSize: 9, color: "black", marginLeft: "15px", backgroundColor: i % 2 === 0 ? "#f9f9f9" : "white" }}>
                <Text style={{ width: "75px", textAlign: "left" }}>{filas.id}</Text>
                <Text style={{ width: "160px", textAlign: "left" }}>{filas.nombres}</Text>
                <Text style={{ width: "160px", textAlign: "left" }}>{filas.apellidos}</Text>
                <Text style={{ width: "130px", textAlign: "right" }}>{filas.valor}</Text>
              </View>
            ))}
            <Text> </Text>
            <View style={{ display: "flex", flexDirection: "row", width: "94%", height: "35px", fontSize: 10, backgroundColor: "#f5f5f5", color: "black", marginLeft: "15px", fontWeight: "bold", borderTop: "2px solid #1976d2" }}>
              <Text style={{ width: "75px", textAlign: "left" }}>Total</Text>
              <Text style={{ width: "160px", textAlign: "left" }}> </Text>
              <Text style={{ width: "160px", textAlign: "left" }}> </Text>
              <Text style={{ width: "130px", textAlign: "right" }}>{totalValorPDF.toFixed(2)}</Text>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    );
  };

  function handlepdf() {
    if (rows.length === 0) {
      alert("No hay datos para procesar este reporte");
    } else {
      setPresentarpdf(true);
    }
  }

  const totalValor = rows.reduce(
    (sum, row) => sum + (parseFloat(String(row.valor || 0).replace(",", "").trim()) || 0),
    0
  );

  return (
    <Box component="main" sx={{ minHeight: "100vh", bgcolor: FP.color.surface }}>
      <PageHeader
        title="Pagos"
        subtitle="Interes Cobrado Periodo"
        cta={
          <Button
            variant="contained"
            startIcon={<FileDownloadRoundedIcon />}
            disabled={rows.length === 0}
            onClick={handlepdf}
            sx={{
              bgcolor: FP.color.navy,
              color: "#FFFFFF",
              borderRadius: 1.4,
              px: 2.2,
              height: 38,
              boxShadow: "none",
              textTransform: "none",
              fontWeight: 700,
              "&:hover": { bgcolor: FP.color.navyDeep, boxShadow: "none" },
              "&.Mui-disabled": { bgcolor: "#E2E8F0", color: "#94A3B8" },
            }}
          >
            Export Data
          </Button>
        }
      />

      <Box sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
        <Card
          elevation={0}
          sx={{
            mb: 3,
            borderRadius: 2.5,
            border: `1px solid ${FP.color.border}`,
            bgcolor: FP.color.cardBg,
            boxShadow: FP.shadow.soft,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              px: { xs: 2, md: 3 },
              py: 1.6,
              borderBottom: `1px solid ${FP.color.border}`,
              bgcolor: "#FAFBFE",
              display: "flex",
              alignItems: "center",
              gap: 1.2,
            }}
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: 1.2,
                bgcolor: FP.color.accentBlueSoft,
                color: FP.color.accentBlue,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FilterAltRoundedIcon sx={{ fontSize: 18 }} />
            </Box>
            <Typography sx={{ fontWeight: 700, color: FP.color.textPrimary, fontSize: "0.98rem" }}>
              Filtros de Búsqueda
            </Typography>
          </Box>
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Grid container spacing={2.5}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="date"
                  label="Fecha Desde"
                  value={fecha1}
                  onChange={(event) => setFecha1(event.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  sx={fpInputSx}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="date"
                  label="Fecha Hasta"
                  value={fecha2}
                  onChange={(event) => setFecha2(event.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  sx={fpInputSx}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Autocomplete
                  disablePortal
                  options={sucursal || []}
                  value={sucursal.find((item) => item?.label === nosucursal) || null}
                  getOptionLabel={(opt) => (opt && opt.label) || ""}
                  isOptionEqualToValue={(opt, val) => (opt && val && opt.label) === (val && val.label)}
                  onChange={(event, value) => setNosucursal(value?.label || "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sucursal"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={fpInputSx}
                    />
                  )}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Box display="flex" justifyContent="flex-end" sx={{ mt: 2.5 }}>
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={() => procesarrequerimiento()}
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  minWidth: { sm: 200 },
                  height: 46,
                  bgcolor: FP.color.navy,
                  color: "#FFFFFF",
                  borderRadius: 1.4,
                  textTransform: "none",
                  fontSize: "0.94rem",
                  fontWeight: 700,
                  boxShadow: "none",
                  "&:hover": { bgcolor: FP.color.navyDeep, boxShadow: "none" },
                }}
              >
                Procesar
              </Button>
            </Box>
          </CardContent>
        </Card>

        {rows.length > 0 && (
          <Box
            sx={{
              display: "grid",
              width: "100%",
              gap: 2,
              mb: 3,
              gridTemplateColumns: {
                xs: "minmax(0, 1fr)",
                sm: "repeat(2, minmax(0, 1fr))",
              },
            }}
          >
            <StatCard
              label="Total de registros"
              value={String(rows.length)}
              icon={DescriptionIcon}
              accent={FP.color.accentBlue}
            />
            <StatCard
              label="Total interés"
              value={`$${totalValor.toLocaleString("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
              icon={TrendingUpIcon}
              accent={FP.color.warning}
            />
          </Box>
        )}

        <Card
          elevation={0}
          sx={{
            borderRadius: 2.5,
            border: `1px solid ${FP.color.border}`,
            bgcolor: FP.color.cardBg,
            boxShadow: FP.shadow.soft,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              px: { xs: 2, md: 3 },
              py: 1.6,
              borderBottom: `1px solid ${FP.color.border}`,
              bgcolor: "#FAFBFE",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <Typography sx={{ fontWeight: 700, color: FP.color.textPrimary, fontSize: "0.98rem" }}>
              Interés cobrado por documento
            </Typography>
            {rows.length > 0 && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<PictureAsPdfIcon />}
                onClick={() => handlepdf()}
                sx={{
                  borderColor: FP.color.danger,
                  color: FP.color.danger,
                  borderRadius: 1.2,
                  textTransform: "none",
                  fontWeight: 700,
                  "&:hover": { bgcolor: FP.color.dangerSoft, borderColor: FP.color.danger },
                }}
              >
                Generar PDF
              </Button>
            )}
          </Box>
          <CardContent sx={{ p: { xs: 1.5, sm: 2 }, "&:last-child": { pb: { xs: 1.5, sm: 2 } } }}>
            {rows.length > 0 ? (
              <>
                <Box sx={{ display: { xs: "none", md: "block" }, width: "100%", overflowX: "auto" }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) =>
                      row.id != null
                        ? String(row.id)
                        : `${String(row.nombres ?? "")}-${String(row.apellidos ?? "")}-${String(row.valor ?? "")}`
                    }
                    pageSizeOptions={[5, 10, 25, 50]}
                    initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                    checkboxSelection
                    disableRowSelectionOnClick
                    rowHeight={42}
                    sx={{ minWidth: { xs: 600, sm: "100%" }, height: 520, ...fpDataGridSx }}
                    autoHeight={false}
                  />
                </Box>
                <Box sx={{ display: { xs: "flex", md: "none" }, flexDirection: "column", gap: 1.4 }}>
                  {rows.map((row, idx) => (
                    <Box
                      key={row.id != null ? String(row.id) : `card-${idx}`}
                      sx={{
                        border: `1px solid ${FP.color.border}`,
                        borderRadius: 2,
                        p: 1.5,
                        bgcolor: "#FFFFFF",
                        boxShadow: FP.shadow.soft,
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1 }}>
                        <Box sx={{ minWidth: 0 }}>
                          <Typography sx={{ fontWeight: 800, color: FP.color.textPrimary, fontSize: "1rem", lineHeight: 1.2 }}>
                            Préstamo #{row.id}
                          </Typography>
                          <Typography sx={{ color: FP.color.textSecondary, fontSize: "0.78rem", mt: 0.25, wordBreak: "break-word" }}>
                            {[row.nombres, row.apellidos].filter(Boolean).join(" ") || "—"}
                          </Typography>
                        </Box>
                        <Box sx={{ flexShrink: 0, textAlign: "right" }}>
                          <Typography sx={{ color: FP.color.textSecondary, fontSize: "0.66rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" }}>
                            Valor
                          </Typography>
                          <Typography sx={{ color: FP.color.textPrimary, fontSize: "1rem", fontWeight: 800, fontVariantNumeric: "tabular-nums" }}>
                            {formatValorCell(row.valor)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </>
            ) : (
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={8}>
                <DescriptionIcon sx={{ fontSize: 56, color: FP.color.textMuted, mb: 2 }} />
                <Typography sx={{ color: FP.color.textPrimary, fontWeight: 700 }} gutterBottom>
                  No hay datos para mostrar
                </Typography>
                <Typography sx={{ color: FP.color.textSecondary, fontSize: "0.9rem" }} textAlign="center" px={2}>
                  Complete los filtros y haga clic en &quot;Procesar&quot; para obtener resultados.
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>

        {presentarpdf && (
          <Dialog
            open={presentarpdf}
            maxWidth="lg"
            fullWidth
            fullScreen={isXs}
            onClose={() => setPresentarpdf(false)}
            PaperProps={{ sx: { borderRadius: { xs: 0, sm: 2 } } }}
          >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">
                Vista Previa del Reporte PDF
              </Typography>
              <Button onClick={() => setPresentarpdf(false)} sx={{ minWidth: "auto", p: 1 }}>
                <CancelIcon />
              </Button>
            </DialogTitle>
            <DialogContent>
              <MyDocument rowsData={rows} nombreNegocio1={nombreNegocio} />
            </DialogContent>
          </Dialog>
        )}
      </Box>
    </Box>
  );
}
export default Interescobradoperiodo;
